
import {of as observableOf,  Observable, EMPTY } from 'rxjs';
// angular
import { Injectable } from '@angular/core';



// interfaces
import { IAuthToken } from '../../../../server/auth/interfaces/authtoken.interface';

@Injectable()
export class AuthServerService {

  get authToken(): Observable<IAuthToken> {
    return observableOf(null);
  }

  get authTokenChange(): Observable<IAuthToken> {
    return EMPTY;
  }

  get isAuthenticated(): boolean {
    return false;
  }

  authenticate(username: string, password: string): Observable<boolean> {
    return observableOf(false);
  }

  invalidate(): void {
    return;
  }
}
